var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTickets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3603 38.1179H53.7352V33.245C53.7352 32.0268 52.7044 30.996 51.4862 30.996H28.9961C27.731 30.996 26.7471 32.0268 26.7471 33.245V38.1179H27.1219C28.1527 38.1179 28.9961 38.9613 28.9961 39.9921C28.9961 41.0697 28.1527 41.8662 27.1219 41.8662H26.7471V46.7391C26.7471 48.0042 27.731 48.9881 28.9961 48.9881H51.4862C52.7044 48.9881 53.7352 48.0042 53.7352 46.7391V41.8662H53.3603C52.2827 41.8662 51.4862 41.0697 51.4862 39.9921C51.4862 38.9613 52.2827 38.1179 53.3603 38.1179ZM51.4862 36.3374C50.1274 37.0402 49.2371 38.399 49.2371 39.9921C49.2371 41.632 50.1274 42.9907 51.4862 43.6936V46.7391H28.9961V43.6936C30.308 42.9907 31.2451 41.632 31.2451 39.9921C31.2451 38.399 30.308 37.0402 28.9961 36.3374V33.245H51.4862V36.3374Z",
    fill: "#808285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6559 49.1566C19.9164 49.5835 19.6631 50.5291 20.09 51.2685C20.5169 52.008 21.4625 52.2613 22.202 51.8344L59.3441 30.3904C60.0836 29.9635 60.3369 29.0179 59.91 28.2784C59.4831 27.539 58.5375 27.2856 57.798 27.7125L20.6559 49.1566Z",
    fill: "#808285",
    stroke: "#F4F4F4",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTickets);
export default __webpack_public_path__ + "static/media/no-tickets.f90154cac551b467ee5ac8733e951ca7.svg";
export { ForwardRef as ReactComponent };